module.exports = __webpack_public_path__ + "img/Custom-Channel-Colors.c54a7dcf.png";